<template>
  <b-button-group vertical class="mapping-controls">
    <b-button v-b-tooltip.hover title="Zoom in" variant="dark" class="pr-3" @click="zoomIn"><icon name="plus" scale=".7"></icon></b-button>
    <b-button v-b-tooltip.hover title="Zoom out" variant="dark" class="pr-3" @click="zoomOut"><icon name="minus" scale=".7"></icon></b-button>
    <b-button v-b-tooltip.hover title="Zoom to bounds" id="zoom_to_bounds" variant="dark" class="pr-3" @click="zoomToCentreline"><icon name="expand" scale=".7"></icon></b-button>
  </b-button-group>
</template>
<script>

export default {
  name: 'map-controls',
  data () {
    return {}
  },
  methods: {
    zoomIn () {this.$mapService.zoomIn()},
    zoomOut () {this.$mapService.zoomOut()},
    zoomToCentreline () {
      let layersZoom = this.$mapService.getLayersToZoom()
      if (!layersZoom.length) {
        this.$notify({
          title: 'ERROR',
          text: 'No common vector layers available',
          type: 'error'
        })
        return
      }
      this.layersZoom = layersZoom
      layersZoom.forEach(l => this.$mapService.zoomToLayer(l))
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/map/MapControls.vue